<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import {doShow as showAlert} from "src/components/cabinet/#common/alert/store"
    import {verifyCode} from 'src/components/cabinet/#services/twoFactorAuthentication'

    let twoFaCode
    let verifySending = false

    async function verifyCodeHandler() {
        try {
            verifySending = true
            await verifyCode.request({ data: { code: twoFaCode } })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            verifySending = false
        }
    }
</script>

<svelte:head>
    <title>Please enter 2FA code</title>
</svelte:head>

<MainLayout title="Please enter 2FA code">
    <svelte:fragment slot="content">
        <div class="cabinet-wrapper">
            <div class="text">Two-factor authentication (2FA) is enabled for your account. Please enter a code to log in.</div>
            <input type="text" class="form-control qr-code-field" bind:value={twoFaCode} placeholder="Enter 2FA code">
            <button class="btn btn-primary" class:loading={verifySending} on:click={verifyCodeHandler}>Verify</button>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .text {
        margin: 90px auto 30px;
        text-align: center;
        max-width: 450px;
    }

    .qr-code-field {
        max-width: 250px;
        text-align: center;
        box-shadow: inset 0 0 0 2px #c2c2c3;
        margin: 10px auto 22px;
        border: 0;
        padding: 8px;
    }

    .btn-primary {
        display: table;
        min-width: 250px;
        margin: 0 auto;
    }

    @media(max-width: 768px) {
        .text {
            margin: 30px auto;
        }
    }
</style>
